import {
    infoOptionsActionDropdownLabel,
    infoOptionsConfirmationDialogLabel,
} from './InfoBarMessageWithOptionsAction.locstring.json';
import loc, { format } from 'owa-localize';
import { observer } from 'mobx-react';
import * as React from 'react';
import { InfoBarOptionsAction, InfoBarOption } from '../schema/InfoBarMessageViewState';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import createInfoBarMessageMenuOptions from '../utils/createInfoBarMessageMenuOptions';

import { confirm, DialogResponse } from 'owa-confirm-dialog';

let styles = require('./InfoBarMessageWithOptionsAction.scss');
let classNames = require('classnames/bind').bind(styles);

export interface InfoBarMessageWithOptionsActionProps extends InfoBarOptionsAction {
    className?: string;
}

@observer
export default class InfoBarMessageWithOptionsAction extends React.Component<
    InfoBarMessageWithOptionsActionProps,
    any
> {
    render() {
        const { preActionText, options } = this.props;

        return (
            <div className={styles.mainContainer}>
                <span className={styles.preActionText}>{preActionText}</span>
                <CommandButton
                    className={styles.multipleOptionCommandButton}
                    menuProps={{
                        gapSpace: 8,
                        items: createInfoBarMessageMenuOptions(options, styles.menuItemText),
                        onItemClick: this.onItemClick,
                    }}
                    onRenderMenuIcon={
                        this.onRenderMenuIcon
                    } /* Renders the icon within the down chevron command button */
                    ariaLabel={loc(infoOptionsActionDropdownLabel)}
                    onRenderText={this.onRenderText(this.props.actionLinkText)}
                />
            </div>
        );
    }

    /**
     * Callback issued when the menu item is invoked
     */
    private onItemClick = (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) => {
        if (item) {
            const { hasSelectionConfirmationDialog, onSelect } = this.props;
            if (hasSelectionConfirmationDialog) {
                const { selectionConfirmDialogFormatString } = this.props;
                const formatString: string =
                    selectionConfirmDialogFormatString || loc(infoOptionsConfirmationDialogLabel);
                const confirmationText: string = format(formatString, item.name);

                confirm('' /* title */, confirmationText /* subtext */).then(response => {
                    if (response == DialogResponse.ok) {
                        onSelect(item.data as InfoBarOption);
                    }
                });
            } else {
                onSelect(item.data as InfoBarOption);
            }
        }
    };

    /**
     * Renders the text within the command button
     */
    private onRenderText = (optionDisplayName: string) => () => {
        return (
            <div className={classNames(styles.commandButtonTextLabel, this.props.className)}>
                {optionDisplayName}
            </div>
        );
    };

    private onRenderMenuIcon = () => null;
}
